require('normalize.css/normalize.css');
require('styles/App.less');
import React, {
  Component,
  PropTypes
} from 'react';
import { Link } from 'react-router'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/const';
import Index from '../components/IndexComponent';
import classnames from 'classnames'
import $ from 'jquery'
import TweenMax from 'gsap'

var isMobileLayout = false

let config = require('config');

let logo               = require('../images/logo.png')
let hamburgerSVG       = require('../images/hamburger.svg')
let mobileHamburgerSVG = require('../images/mobile_hamburger.svg')
let smallHamburgerSVG  = require('../images/small_hamburger.svg')
let smallGototopSVG    = require('../images/small_gototop.svg')

var circleDef = require('../images/scroll.svg')
var circleOv  = require('../images/scroll_ov.svg')

var hamburgerStyle       = { backgroundImage:'url(' + hamburgerSVG + ')' }
var mobileHamburgerStyle = { backgroundImage:'url(' + mobileHamburgerSVG + ')' }
var smallHamburgerStyle  = { backgroundImage:'url(' + smallHamburgerSVG + ')' }
var smallGototopStyle    = { backgroundImage:'url(' + smallGototopSVG + ')' }

var browser = {
  ua:null,
  init:function()
  {
    this.ua = navigator.userAgent.toLowerCase();
    this.ua = {
      isLtIE9   : document.uniqueID && typeof window.matchMedia == 'undefined',
      isIE      : document.uniqueID,
      isChrome  : /chrome/.test(this.ua),
      isMobile  : /mobile/.test(this.ua),
      isIOS     : /i(phone|pod|pad)/.test(this.ua),
      isAndroid : /android/.test(this.ua)
    }
  },
  isMobile:function()
  {
    if (this.ua.isIOS || this.ua.isAndroid || this.ua.isMobile) return true;
    else false;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    browser.init()
    if (browser.isMobile()) $('html').addClass('mobile')
    this.state = {
      isOver:false,
      isMobile:false
    }
    this.indexopen = this.indexopen.bind(this);
    this.gohome = this.gohome.bind(this);
    this.event()
  }
  event() {
    $(window).on('scroll', this.scroll.bind(this))
  }
  scroll() {
    var scrollTop = $(window).scrollTop()
    if (scrollTop > 220) {
      $('header#small').addClass('appear')
    } else {
      $('header#small').removeClass('appear')
    }
    $('#content .post').each(function() {
      if ($(this).offset().top - 50 < scrollTop) {
        $('header#small h1').text($(this).find('.title').text())
      }
    })
  }
  componentDidMount() {
    const { actions } = this.props;
    actions.getTotalShowPage();
    actions.getIndexPage()
    actions.getCategories()
  }
  indexopen() {
    const { actions } = this.props;
    actions.indexOpen($(window).scrollTop())
  }
  gototop() {
    TweenMax.to('body, html', 0.5, {scrollTop:0, ease:'easeInOutExpo'})
  }
  gohome() {
    document.title = config.default.SITE_NAME
  }
  render() {
    const {actions, data, children} = this.props;
    var indexCl, mainCl
    if (data.indexOpen) {
      indexCl = classnames({ appear:true })
      mainCl  = classnames({ disappear:true })
    } else {
      indexCl = classnames({ appear:false })
      mainCl  = classnames({ disappear:false })
    }
    return (
      <div id="container">
        <div id='index' className={indexCl}>
          { data.indexOpen ?
            <Index ref='index' actions={actions} data={data} />
          :null}
        </div>
        <div id='main' className={mainCl}>
          <header id='header'>
            <a className='open pc' onClick={this.indexopen}><span style={hamburgerStyle}></span></a>
            <a className='open mobile' onClick={this.indexopen}><span style={mobileHamburgerStyle}></span></a>
            { this.props.route.isPreview ?
              <h1><a href='/'><img src={logo} alt={config.default.SITE_NAME}/></a></h1>
            :
              <h1><Link to='/' onClick={this.gohome}><img src={logo} alt={config.default.SITE_NAME}/></Link></h1>
            }
          </header>
          <header id='small'>
            <div className='inner'>
            <a className='open' onClick={this.indexopen}><span style={smallHamburgerStyle}></span></a>
              <a className='gototop' onClick={this.gototop}><span style={smallGototopStyle}></span></a>
              <h1></h1>
            </div>
          </header>
          <div id="content">{children}</div>
          <footer className='tfooter'>
            <div className='inner'><p>system by <a href='http://everythingbuttheinternet.com/' target='_blank'>everything but the internet</a></p></div>
          </footer>
        </div>
      </div>
    )
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const props = {
    data:state.data
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js